import {noop} from '@web-utilities/other';
import type {ReactNode} from 'react';

import {FilterPopover} from '../../../FilterPopover';

interface FilterItemProps {
  filter?: ReactNode;
  hideClearButton?: boolean;
  onClear?(): void;
}

export function FilterItem({
  filter,
  hideClearButton,
  onClear,
}: FilterItemProps) {
  const filterPopoverMarkup = (
    <FilterPopover
      filter={filter}
      hideClearButton={hideClearButton}
      onClear={onClear || noop}
    />
  );

  return <li>{filterPopoverMarkup}</li>;
}
